export default {
	id: "",
	property: "",
	name: "",
	legal_name: "",
	developers: "",
	neighborhood: 0,
	default_developer: "",
	subdivision: "",
	description: "",
	isd: "",
	acreage: "",
	sqft_min: "",
	sqft_max: "",
	mud: "",
	lid: "",
	completion: "",
	platted_lots: "",
	default_lot_type_id: "",
	plat_num: "",
	plat_record_date: "",
	plat_file: "",
	fence_plat_file: "",
	tmp_plat_id: "",
	plat_upload_date: "",
	reserves: "",
	substantially_complete: "",
	estimated_delivery: "",
	tract: "",
	senior: "",
	gated: "",
	btr: "",
	high_school: "",
	middle_school: "",
	elementary_school: "",
	direct_to_prospect: "",
	lot_types_tax_values: "",
	model_park: ""
}